import { LimitlessBrand } from "../LimitlessBrand";
import { getThemeBase } from "./ThemeBase";
import { getButtonOverrides } from "@limitless/modern/inputs/button/ComponentOverrides";
import { getIconButtonOverrides } from "@limitless/modern/inputs/icon-button/ComponentOverrides";
import { getSwitchOverrides } from "@limitless/modern/inputs/switch/ComponentOverrides";
import { getTextFieldOverrides } from "@limitless/modern/inputs/text-field/ComponentOverrides";
import { getBreadcrumbsOverrides } from "@limitless/modern/navigation/breadcrumbs/ComponentOverrides";
import { getMenuOverrides } from "@limitless/modern/navigation/menu/ComponentOverrides";
import { getDropdownMenuOverrides } from "@limitless/modern/inputs/dropdown-menu/ComponentOverrides";
import { getAlertOverrides } from "@limitless/modern/feedback/alert/ComponentOverrides";
import { getBadgeOverrides } from "@limitless/modern/feedback/badge/ComponentOverrides";
import { getPaperOverrides } from "@limitless/modern/surfaces/paper/ComponentOverrides";
import { getDialogOverrides } from "@limitless/modern/feedback/dialog/ComponentOverrides";
import { getRadioGroupOverrides } from "@limitless/modern/inputs/radio-group/ComponentOverrides";
import { getDataTableOverrides } from "@limitless/modern/data-display/table/ComponentOverrides";
import { getChipOverrides } from "@limitless/modern/data-display/chip/ComponentOverrides";
import { getAccordionOverrides } from "@limitless/modern/surfaces/accordion/ComponentOverrides";
import { getAvatarOverrides } from "@limitless/modern/data-display/avatar/ComponentOverrides";
const typography = LimitlessBrand.typography;
export const getComponentOverrides = mode => {
  const theme = getThemeBase(mode);
  return {
    components: {
      ...getButtonOverrides(theme, typography),
      ...getIconButtonOverrides(theme),
      ...getSwitchOverrides(theme),
      ...getTextFieldOverrides(theme, typography),
      ...getBreadcrumbsOverrides(theme, typography),
      ...getMenuOverrides(theme),
      ...getDropdownMenuOverrides(theme),
      ...getAlertOverrides(theme),
      ...getBadgeOverrides(theme),
      ...getPaperOverrides(theme),
      ...getDialogOverrides(theme, typography),
      ...getDataTableOverrides(theme),
      ...getRadioGroupOverrides(theme),
      ...getChipOverrides(theme, typography),
      ...getAvatarOverrides(theme),
      ...getAccordionOverrides(theme)
    }
  };
};